import { render, staticRenderFns } from "./AtlasFileEdit.vue?vue&type=template&id=08869d4a"
import script from "./AtlasFileEdit.vue?vue&type=script&lang=ts"
export * from "./AtlasFileEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports